import React from 'react'

interface Props {
    title: string | undefined,
    subtitle: string | undefined,
    actions?: React.ReactNode
}

const BasicPageTitle = ({ title, subtitle, actions }: Props) => {
    return (
        <div className="mb-2 d-flex justify-content-between align-items-end">
            <div className="d-flex">
                <div className="fs-1 fw-bolder">{title}</div>
                <div className="fw-light align-self-end ms-2 pb-2">{subtitle}</div>
            </div>
            {actions && <div>{actions}</div>}
        </div>
    )
}

export default BasicPageTitle
